import React, { useState, useEffect } from 'react';
import { InputItem, Button, Picker, Icon } from 'antd-mobile';

export default (props: any) => {
  const { isEdit, value, mobileValue, changeFormValue, onMobileChange, selectedArea, setSelectedArea, areaCode, setVerifyCode, sendVerificationCode } = props;
  // 计时器
  const [codeCountDown, setCodeCountDown] = useState(0);

  // 倒计时计时器
  useEffect(() => {
    setTimeout(() => {
      if (codeCountDown > 0) {
        setCodeCountDown(prevCount => prevCount - 1);
      }
    }, 1000);
  }, [codeCountDown]);

  const mobileInputProps = mobileValue !== undefined ? { value: mobileValue } : {}

  return (
    <div>
      <div className='JSPhoneItem'>
        <InputItem
          type={"phone"}
          placeholder={"请输入手机号"}
          onChange={(text) => {
            changeFormValue && changeFormValue(text, value);
            onMobileChange && onMobileChange(text)
          }}
          maxLength={13}
          disabled={!!isEdit}
          extra={!isEdit
            ? (
              <Button
                className="phoneCodeBtn"
                // 发送验证码
                onClick={() => {
                  sendVerificationCode(() => setCodeCountDown(60));
                }}
                disabled={codeCountDown > 0}
                type='primary'
                size='small'
                style={{ padding: "0 5px" }}
              >
                {codeCountDown <= 0 ? "发送验证码" : `${codeCountDown}秒`}
              </Button>
            )
            : (<div />)}
          {...mobileInputProps}
        >
          <Picker
            data={areaCode}
            cols={1}
            onOk={([v]) => setSelectedArea(v)}
          >
            <Button className="leftBtn">
              <span style={{ color: "red" }}>*</span>
              {`手机号(+${selectedArea})`}
              <Icon color="#333" size="md" type="down" />
              {`:`}
            </Button>
          </Picker>
        </InputItem>
      </div>
      {!isEdit && (
        <InputItem
          onChange={(text) => {
            if (text.length <= 6) {
              setVerifyCode(text);
            }
            return;
          }}
          maxLength={6}
          type="number"
          placeholder={"请输入验证码"}
        >
          <span style={{ color: "red" }}>*</span>
          <span>验证码:</span>
        </InputItem>
      )}
    </div>
  )
}